import React, { RefObject, useCallback } from 'react';

import { tracker } from 'src/utils/analytics';
import { Tooltip } from 'src/components/tooltip';

import { useLoginNudge } from './use-login-nudge';
import { TextContainer, LoginLink, SocialLoginContainer, SocialButtonContainer } from './login-nudge.styles';
import { AppleIcon, GoogleIcon } from './icons';
import { useLoginNudgePosition } from './use-login-nudge-position';

type LoginNudgeProps = {
  anchorEl: RefObject<HTMLElement> | null;
  containerRef: RefObject<HTMLElement> | null;
};

export const LoginNudge = ({ anchorEl, containerRef }: LoginNudgeProps): JSX.Element | null => {
  const { dismissNudge, handleNudgeClick, shouldShowNudge } = useLoginNudge();
  const { position } = useLoginNudgePosition({ anchorEl, containerRef });
  const onImpression = useCallback(() => tracker.loginNudge({ action: 'viewed' }), []);
  const onClose = useCallback(() => {
    dismissNudge();
    tracker.loginNudge({ action: 'dismissed' });
  }, [dismissNudge]);
  if (!shouldShowNudge || !position || !anchorEl?.current || !containerRef?.current) {
    return null;
  }

  return (
    <Tooltip
      dataTestId='login-nudge'
      ariaLabel='Login Nudge'
      position={position}
      onClose={onClose}
      onContentClick={handleNudgeClick}
      onImpression={onImpression}
    >
      <TextContainer>
        <LoginLink>Login</LoginLink> for recommendations & re‑ordering of your favorites
      </TextContainer>
      <SocialLoginContainer>
        <SocialButtonContainer aria-label='Login with Google'>
          <GoogleIcon />
        </SocialButtonContainer>
        <SocialButtonContainer aria-label='Login with Apple'>
          <AppleIcon />
        </SocialButtonContainer>
      </SocialLoginContainer>
    </Tooltip>
  );
};
